import { type DependencyList, useEffect } from 'react';

export const useAsyncEffect = (
  promise: () => Promise<any>,
  deps: DependencyList = []
) => {
  return useEffect(() => {
    promise();
  }, deps);
};
